import { render } from "./BoxWrapper.vue?vue&type=template&id=a743b79a"
import script from "./BoxWrapper.vue?vue&type=script&lang=js"
export * from "./BoxWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__